<div
  class="fp"
  [class.fp--visible]="visible"
  role="progressbar"
  aria-label="Searching for flights"
  aria-valuemin="0"
  aria-valuemax="100"
  [attr.aria-valuenow]="progress | number:'1.0-0'"
  [attr.aria-hidden]="!visible">
  <div class="fp__track">
    <div class="fp__fill" [style.width.%]="progress"></div>
    <span class="fp__plane" [style.left.%]="progress" aria-hidden="true">
      <i class="fas fa-plane"></i>
    </span>
  </div>
</div>
